import * as React from 'react'
import { useQuery } from '@tanstack/react-query'
import { FilterDropdown } from '@/components/ui/filter-dropdown'
import { getJSON } from '@/lib/api'

export function OwnerFilter({
  value,
  onChange,
}: {
  value?: string
  onChange: (value?: string) => void
}) {
  const connectionsQuery = useQuery({
    queryKey: ['connections', 'owner-filter'],
    queryFn: () =>
      getJSON<{ connections: Array<{ id: number; display_name: string }> }>('/api/v1/connections'),
    retry: false,
  })
  const selected = value ? new Set([value]) : new Set<string>()

  return (
    <FilterDropdown
      label="Owner"
      emptyLabel="All owners"
      options={[
        { value: 'bright_huddle', label: 'Bright Huddle' },
        ...(connectionsQuery.data?.connections ?? []).map((connection) => ({
          value: String(connection.id),
          label: connection.display_name,
        })),
      ]}
      selected={selected}
      onChange={(next) => onChange(Array.from(next).at(-1))}
    />
  )
}
